import { IFeatureToggles } from "redux/modules/setup/setup.types";
import { ISettings } from "redux/application.types";

const getIfDefined = (variable: boolean | undefined, defaultValue: boolean) =>
    typeof variable === "undefined" ? defaultValue : variable;

/**
 * Filter ISettings to get app feature toggles only providing default values
 */
export const getFeaturesFromSettings = (settings: ISettings): IFeatureToggles => {
    const {
        blockedQueryStateEnabled,
        callFunctionalityEnabled,
        chatFunctionalityEnabled,
        departmentRestrictedBrandsEnabled,
        departmentRestrictedSetupsEnabled,
        departmentRestrictedTransfersEnabled,
        emailFunctionalityEnabled,
        emailSkillsEnabled,
        proactiveChatEnabled,
    } = settings;
    return {
        blockedQueryStateEnabled: getIfDefined(blockedQueryStateEnabled, true),
        callFunctionalityEnabled: getIfDefined(callFunctionalityEnabled, true),
        chatFunctionalityEnabled: getIfDefined(chatFunctionalityEnabled, true),
        departmentRestrictedBrandsEnabled: getIfDefined(departmentRestrictedBrandsEnabled, false),
        departmentRestrictedSetupsEnabled: getIfDefined(departmentRestrictedSetupsEnabled, false),
        departmentRestrictedTransfersEnabled: getIfDefined(departmentRestrictedTransfersEnabled, true),
        emailFunctionalityEnabled: getIfDefined(emailFunctionalityEnabled, true),
        emailSkillsEnabled: getIfDefined(emailSkillsEnabled, true),
        proactiveChatEnabled: getIfDefined(proactiveChatEnabled, true),
    };
};
